import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonCard, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";

const AllClasses: React.FC = () => {

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery"; // Set page title
    }, []);

    return (
        <IonContent>
            <Header />
            <IonCard className='privacy-policy-section'>
                <h1 className='text-center font-50'>Classes</h1>
                <section className="classes-section">
                    <div className="classes-header">
                        <h2>🎓 Explore Learning by Class</h2>
                        <p>Select your child’s class to access worksheets, quizzes, and Olympiad practice.</p>
                    </div>

                    <div className="classes-grid">
                        <div className="class-card lkg">
                            <h3>🧸 Nursery</h3>
                            <p>Early concepts, fun learning.</p>
                            <Link to="/nursery">Explore Nursery</Link>
                        </div>
                        <div className="class-card lkg">
                            <h3>🧸 LKG</h3>
                            <p>Spark curiosity and build strong early learning foundations.</p>
                            <Link to="/lkg">Explore LKG</Link>
                        </div>

                        <div className="class-card ukg">
                            <h3>🎈 UKG</h3>
                            <p>Hands-on learning with games, stories, and practice.</p>
                            <Link to="/ukg">Explore UKG</Link>
                        </div>

                        <div className="class-card class1">
                            <h3>📘 Class 1</h3>
                            <p>Structured topics, Olympiad prep, and reasoning skills.</p>
                            <Link to="/class-one">Explore Class 1</Link>
                        </div>

                        <div className="class-card class2">
                            <h3>📗 Class 2</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-two">Explore Class 2</Link>
                        </div>

                        <div className="class-card class3">
                            <h3>📕 Class 3</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-three">Explore Class 3</Link>
                        </div>

                        <div className="class-card class4">
                            <h3>📙 Class 4</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-four">Explore Class 4</Link>
                        </div>

                        <div className="class-card class5">
                            <h3>📔 Class 5</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-five">Explore Class 5</Link>
                        </div>
                    </div>
                </section>
            </IonCard>
            <Footer />
        </IonContent>
    );
};
export default AllClasses;